import { atom } from "jotai";

export const dateAtom = atom(new Date().toISOString().slice(0, 10));
